import { useQuery } from "@tanstack/react-query";
import { ACTIVITY_LOGS_QUERY_KEY } from "../constants";
import { ActivityService } from "../services/activity.service";
import { IActivityLogSearchQuery } from "../types";

export function useSearchActivityLogs(params: IActivityLogSearchQuery) {
  const {
    data: activityLogs,
    error: activityLogsError,
    isSuccess: isActivityLogsSuccess,
    isFetching: isActivityLogsFetching,
    refetch: refetchActivityLogs,
  } = useQuery({
    queryKey: [...ACTIVITY_LOGS_QUERY_KEY, params],
    queryFn: () => ActivityService.searchActivityLogs(params),
    enabled:
      !!params.brandOrganisationIds && params.brandOrganisationIds?.length > 0,
  });

  return {
    activityLogs,
    activityLogsError,
    isActivityLogsSuccess,
    isActivityLogsFetching,
    refetchActivityLogs,
  };
}
